import './App.css';

function App() {

  return (
    <div className="App">
       <div className='app-header'>
          <h1>React Developer Club J&K</h1>
          <h2>Launching soon...🚀</h2>
          <p>For more info</p>
        <div className='link-container'>

        <a className="link info" href="mailto:reactdevclubjandk@gmail.com">Contact Us</a>
          <a className="link info" href="https://www.linkedin.com/company/react-club-j-k" target="_blank" rel="noreferrer">LinkedIn</a>
          <a className="link info" href="https://www.youtube.com/channel/UCP01QImEhbbsr3ABTVHvPTA" target="_blank" rel="noreferrer"> YouTube</a>
          <a className="link info" href="https://discord.gg/HpfwDmjEnR" target="_blank" rel="noreferrer"> Discord</a>

        </div>
      </div>      
     </div>
  );
}

export default App;
